import template from './template.html'

angular
  .module('contabilidad.reportesexternos')
  .component('contabilidadReportesexternosProductosmasvendidosDatos', {
    controller: ContabilidadReportesexternosProductosmasvendidosDatosComponent,
    template,
    bindings: {
      busqueda: '<',
    },
  })

function ContabilidadReportesexternosProductosmasvendidosDatosComponent (ReportesexternosProductosmasVendidosService, $document) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.copiar = copiar

  function $onInit () {
    $ctrl.copiable = $document[0].queryCommandSupported('copy')
    $ctrl.promise = ReportesexternosProductosmasVendidosService.get($ctrl.busqueda)
      .then(function (resolve) {
        $ctrl.data = resolve.data
        arreglardatos()
      })
  }

  function arreglardatos () {
    var texto = ''
    var encabezados = Object.keys($ctrl.data.productos[0])
    texto += encabezados.join('\t')
    var ids_productos = Object.keys($ctrl.data.proveedores)
    var proveedores = []
    ids_productos.forEach(function (item) {
      $ctrl.data.proveedores[item].forEach(function (proveedor) {
        if (!proveedores.includes(proveedor.proveedor)) {
          proveedores.push(proveedor.proveedor)
        }
      })
    })
    proveedores.forEach(function (item) {
      texto += '\t' + item + '\t' + 'Última compra'
    })
    texto += '\n'
    $ctrl.data.productos.forEach(function (item) {
      encabezados.forEach(function (prop) {
        texto += item[prop] + '\t'
      })
      proveedores.forEach(function (columna, indice) {
        if ($ctrl.data.proveedores[item.id_prod]) {
          var precios = $ctrl.data.proveedores[item.id_prod]
          var indice = precios.findIndex(function (precio) {
            return precio.proveedor == columna
          })
          texto += indice >= 0 ? (precios[indice].costo + '\t' + precios[indice].fecha) : ('0' + '\t' + '-')
        } else {
          texto += '0' + '\t' + '-'
        }
        texto += indice == proveedores.length - 1 ? '' : '\t'
      })
      texto += '\n'
    })

    $ctrl.cadena = texto
  }

  function copiar () {
    var elemento = $document[0].getElementById('contabilidad.reportesexternos.masvendidos.datos')
    elemento.focus()
    elemento.select()
    document.execCommand('copy')
  }

}



// WEBPACK FOOTER //
// ./src/contabilidad/reportesexternos/components/productosmasvendidos/datos/component.js